import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export function extendPropsWithContext(props) {
  let defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  props = _objectSpread(_objectSpread({}, defaults), props);
  for (var _len = arguments.length, contexts = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    contexts[_key - 2] = arguments[_key];
  }
  return _objectSpread(_objectSpread({}, props), reduceContextWithValue(props, defaults, contexts));
}
export function extendPropsWithContextInClassComponent(props) {
  let defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  for (var _len2 = arguments.length, contexts = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    contexts[_key2 - 2] = arguments[_key2];
  }
  return _objectSpread(_objectSpread({}, props), reduceContextWithValue(props, defaults, contexts, {
    checkPropKey: true
  }));
}
function reduceContext(contexts) {
  return contexts.reduce((acc, cur) => {
    if (cur) {
      acc = _objectSpread(_objectSpread({}, acc), cur);
    }
    return acc;
  }, {});
}
function reduceContextWithValue(props, defaults, contexts) {
  let {
    checkPropKey = false
  } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const context = reduceContext(contexts);
  return Object.entries(context).reduce((acc, _ref) => {
    let [key, value] = _ref;
    if ((checkPropKey ? Object.prototype.hasOwnProperty.call(props, key) : true) && props[key] === (defaults === null || defaults === void 0 ? void 0 : defaults[key])) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
//# sourceMappingURL=extendPropsWithContext.js.map